module.exports = __webpack_public_path__ + "img/election-infrastructure-diagram.ea1d248b.png";